import React, { useContext, useEffect, useState } from "react";
import BarChart from "./BarChart";
import AuthContext from "../../../contexts/auth-context";
import useAxios from "../../../hooks/useAxios";
import { urls } from "../../config/variables";
import { validateProvidersWithHighRejectionRates } from "../../../Utils/validateHttpResponse";
import Toastify from "../../ui/Toastify";
import { toastify_status } from "../../config/variables";
import AppContext from "../../../contexts/app-context";

const ProvidersWithHighRejectionRates = () => {
  const [data, setData] = useState([]);
  const { operation } = useAxios();
  const authCtx = useContext(AuthContext)
  const token = authCtx.token;
  const { globalFilterQuery } = useContext(AppContext);

  const fetchData = () => {
    operation(
      {
        method: 'GET',
        url: urls.PROVIDERS_WITH_HIGH_REJECTION_RATES + globalFilterQuery,
        headers: { Authorization: `token ${token}` },
        data: {},
      },
      handleSetData,
      handleSetDataError
    );
  }
  useEffect(() => {
      fetchData()
      // eslint-disable-next-line
  }, []);
  
  const handleSetData = (response) => {
      if (validateProvidersWithHighRejectionRates(response)) {
      setData(response);
    } else {
      Toastify({
        message: "Invalid providers with high rejection rates response data",
        state: toastify_status.ERROR,
      });
    }
  }

  const handleSetDataError = (error) => {
    console.log(error)
  }

  const xAxisData = data.map((item) => item.provider_name);
  const rejectionRates = data.map((item) => parseFloat(item.rejection_rate));

  const option = {
    title: {
      text: "Providers with High Rejection Rates",
      subtext: 'Providers with rejection rates of 90% or higher (minimum 10 encounters)',
      left: "center",
      top: 10,
      textStyle: {
        fontSize: 16,
        fontWeight: "bold",
      },
    },
    legend: {
      data: ["Rejection Rate"],
      type: "scroll",
      bottom: 1,
      left: "center",
      icon: "rect",
      itemWidth: 20,
      itemHeight: 10,
      textStyle: {
        fontSize: 12,
      },
    },
    tooltip: {
      trigger: "axis",
      formatter: (params) => {
        const { name, value } = params[0];
        const provider = data.find((d) => d.provider_name === name);
        return `
          <b>${name}</b><br/>
          Rejection Rate: ${value}%<br/>
          Rejected Encounters: ${provider.rejected_encounters_count}<br/>
          Total Encounters: ${provider.total_encounters}
        `;
      },
    },
    xAxis: {
      type: "category",
      data: xAxisData,
      axisLabel: {
        interval: 0,
        overflow: "break",
        formatter: function (value) {
          const maxLength = 25;
          if (value.length > maxLength) {
            return value.match(new RegExp('.{1,' + maxLength + '}', 'g')).join('\n');
          }
          return value;
        },
      },
    },
    yAxis: {
      type: "value",
      axisLabel: {
        formatter: (val) => `${val}%`,
      },
      max: 100,
    },
    series: [
      {
        name: "Rejection Rate",
        type: "bar",
        data: rejectionRates,
        itemStyle: {
          color: (params) =>
            params.value > 90
              ? "#E74C3C" // red for very high
              : params.value > 70
              ? "#F39C12" // orange for moderate
              : "#2ECC71", // green otherwise
        },
        label: {
          show: true,
          position: "top",
          formatter: "{c}%",
        },
      },
    ],
    grid: {
      top: 80,
      bottom: 60,
      left: 60,
      right: 30,
    },
  };

  return <BarChart name="Providers With High Rejection Rates" option={option} dataLength={data.length}/>;
};

export default ProvidersWithHighRejectionRates;
